import { Locale } from "@/enums";
import { useTranslation } from "react-i18next"

export const useLanguage = () => {
    const { i18n } = useTranslation();
    return {
        [Locale.EN_MY]: 'en',
        [Locale.MS_MY]: 'my',
        [Locale.EN_PH]: 'en',
    }[i18n.language as Locale];
}
